export const paginationFeatureKey = 'pagination';
